import { render } from "./ProfileAnswers.vue?vue&type=template&id=2927737b&scoped=true&ts=true"
import script from "./ProfileAnswers.vue?vue&type=script&lang=ts"
export * from "./ProfileAnswers.vue?vue&type=script&lang=ts"

import "./ProfileAnswers.vue?vue&type=style&index=0&id=2927737b&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2927737b"]])

export default __exports__